import React, { useState } from "react";
import Configurationcontext from "./Configurationcontext";
import configurationAPI from "../../apis/configuration/configurationAPI";
import configurationConstants from "../../apis/configuration/configurationConstants";

const ConfigurationContextProvider = ({ children }) => {
  const [messageSave, setMessageSave] = useState("Save");
  const [saveConfiguration, setSaveConfiguration] = useState({});
  const [resetForm, setResetForm] = useState(
    configurationConstants.GENERAL_CONFIGURATION,
  );
  const [locationData, setLocationData] = useState([]);
  const [lastLocationUpdated, setLastLocationUpdated] = useState(null);
  const [client, setClient] = useState([]);
  const [configrationprocesses, setConfigrationProcesses] = useState([]);
  const [doesLocationSupportProcessWiseCoding, setDoesLocationSupportProcessWiseCoding] = useState(false);
  const [configrationSpecialities, setConfigrationSpecialities] = useState([]);
  const [configprimaryDiagnosis, setConfigprimaryDiagnosis] = useState([]);
  const [configSecondaryDiagnosis, setConfigSecondaryDiagnosis] = useState([]);
  const [configProcedures, setConfigProcedures] = useState([]);
  const [configEd, setConfigEd] = useState([]);
  const [configModifier, setConfigModifier] = useState([]);
  const [configPOA, setConfigPOA] = useState([]);
  const [configDrug, setConfigDrug] = useState([]);
  const [configSubSpeciality, setConfigSubSpeciality] = useState([]);
  const [configAuditOptions, setConfigAuditOptions] = useState([]);
  const [configFeedbackTypes, setConfigFeedbackTypes] = useState([]);
  const [configHoldReasons, setConfigHoldReasons] = useState([]);
  const [configResponsibleParties, setConfigResponsibleParties] = useState([]);
  const [configDisposition, setConfigDisposition] = useState([]);
  const [configPrimaryHealth, setConfigPrimaryHealth] = useState([]);
  const [configFacility, setConfigFacility] = useState([]);
  const [fieldValidationConfig, setFieldValidationConfig] = useState({});
  const [configurableFieldsCount, setConfigurableFieldsCount] = useState(0);
  const [submitData, setSubmitData] = useState({
    LOCATION_CONFIGURATION: {},
    GENERAL_CONFIGURATION: {},
    FEEDBACK_CONFIGURATION: {},
    AUDITING_CONFIGURATION: {},
    CODING_CONFIGURATION: {},
    CHART_FIELD_CONFIGURATION: {},
  });

  const [editedData, setEditedData] = useState({
    GENERAL_CONFIGURATION: {},
    FEEDBACK_CONFIGURATION: {},
    AUDITING_CONFIGURATION: {},
    CODING_CONFIGURATION: {},
    CHART_FIELD_CONFIGURATION: {},
  });

  const onAddClick = (form, key) => {
    let formData = submitData[form];
    if (formData === undefined) formData = {};
    let dataField = formData[key];
    if (dataField === undefined) dataField = [];
    dataField = [...dataField, ""];
    formData[key] = dataField;
    submitData[form] = formData;
    setSubmitData({ ...submitData });
  };

  const emptyData = () => {
    let localEditData = editedData;
    localEditData[resetForm] = {};
    // setEditedData({
    //   ...localEditData,
    // });
    setEditedData({
      GENERAL_CONFIGURATION: {},
      FEEDBACK_CONFIGURATION: {},
      AUDITING_CONFIGURATION: {},
      CODING_CONFIGURATION: {},
      CHART_FIELD_CONFIGURATION: {},
    });
    let localSubmitData = submitData;
    localSubmitData[resetForm] = {};
    // setSubmitData({
    //   ...localSubmitData,
    // });
    setSubmitData({
      LOCATION_CONFIGURATION: {},
      GENERAL_CONFIGURATION: {},
      FEEDBACK_CONFIGURATION: {},
      AUDITING_CONFIGURATION: {},
      CODING_CONFIGURATION: {},
      CHART_FIELD_CONFIGURATION: {},
    });
  };

  const onDeleteClick = (form, key, index) => {
    let formData = submitData[form];
    if (formData === undefined) formData = {};
    let dataField = formData[key];
    if (dataField === undefined) {
      dataField = [];
    } else {
      dataField.splice(index, 1);
    }
    formData[key] = dataField;
    submitData[form] = formData;
    setSubmitData({ ...submitData });
  };

  const onFieldChange = (form, key, index, value) => {
    let formData = submitData[form];
    if (formData === undefined) formData = {};
    let dataField = formData[key];
    if (dataField === undefined) {
      dataField = [];
    } else {
      dataField[index] = value;
    }
    formData[key] = dataField;
    submitData[form] = formData;
    setSubmitData({ ...submitData });
  };
  
  const onFieldConfigurationChange = (form, key, value) => {
    let formData = submitData[form];
    if (formData === undefined) formData = {};
    let dataField = formData[key];
    dataField = value;
    formData[key] = dataField;
    submitData[form] = formData;
    setSubmitData({ ...submitData });
  };

  const onEditFieldChange = (form, key, id, value) => {
    let formData = editedData[form];
    if (formData === undefined) formData = {};
    let dataField = formData[key];
    if (dataField === undefined) dataField = {};
    dataField[id] = value;
    formData[key] = dataField;
    editedData[form] = formData;
    setEditedData({ ...editedData });
  };

  const onformSubmit = async (
    form,
    selectedLoc,
    isChecked,
    clientCurrentId,
  ) => {
    try {
      let configurationData = {
        newData: submitData[form],
        editData: editedData[form],
        locationId: selectedLoc,
        sameForAllLocationCheckedOrNot: isChecked,
        clientCurrentId: clientCurrentId,
      };
      if(form === configurationConstants.CHART_FIELD_CONFIGURATION) {
        if(configurableFieldsCount !== Object.keys(submitData[form]).length) {
          return {"success": false, message: 'All fields must be marked in Chart Field Configuration tab'};
        } else {
          configurationData = {...configurationData, newData: {chartFieldConfiguration: submitData[form], chartFieldConfigurationSpecId: submitData['SpecialtyId']}, editData: {}};
        }
      }
      var response = await configurationAPI.submitConfigurationForm(configurationData);
      if (response.success) {
        setResetForm(form);
        setSaveConfiguration(response);
        setSubmitData({
          LOCATION_CONFIGURATION: {},
          GENERAL_CONFIGURATION: {},
          FEEDBACK_CONFIGURATION: {},
          AUDITING_CONFIGURATION: {},
          CODING_CONFIGURATION: {},
          CHART_FIELD_CONFIGURATION: {},
        });

        setEditedData({
          GENERAL_CONFIGURATION: {},
          FEEDBACK_CONFIGURATION: {},
          AUDITING_CONFIGURATION: {},
          CODING_CONFIGURATION: {},
          CHART_FIELD_CONFIGURATION: {},
        });
      }
      return response;
    } catch (e) {
      console.log(e);
      return e;
    }
  };

  const onformCancel = async (form) => {
    try {
      await setResetForm(form);
    } catch (e) {
      console.log(e);
      return e;
    }
  };

  const onformSubmitLocation = async (form, client_id) => {
    try {
      var response = await configurationAPI.submitLocationConfiguration({
        client_id: client_id,
        newData: submitData[form],
      });
      if (response?.success) {
        setResetForm(form);
        setSaveConfiguration(response);
      }
      return response;
    } catch (e) {
      console.log(e);
      return e;
    }
  };

  return (
    <Configurationcontext.Provider
      value={{
        onAddClick,
        onDeleteClick,
        onFieldChange,
        onFieldConfigurationChange,
        onformSubmit,
        emptyData,
        editedData,
        fieldValidationConfig,
        configurableFieldsCount,
        onEditFieldChange,
        saveConfiguration,
        setSaveConfiguration,
        locationData,
        lastLocationUpdated,
        client,
        configrationprocesses,
        configrationSpecialities,
        configprimaryDiagnosis,
        configSecondaryDiagnosis,
        configProcedures,
        configEd,
        configModifier,
        configPOA,
        configDrug,
        configSubSpeciality,
        configAuditOptions,
        configFeedbackTypes,
        configHoldReasons,
        configPrimaryHealth,
        configFacility,
        configResponsibleParties,
        submitData,
        configDisposition,
        setSubmitData,
        onformSubmitLocation,
        messageSave,
        setLocationData,
        setLastLocationUpdated,
        setClient,
        setConfigrationProcesses,
        setConfigrationSpecialities,
        setConfigprimaryDiagnosis,
        setConfigSecondaryDiagnosis,
        setConfigProcedures,
        setConfigEd,
        setConfigModifier,
        setConfigPOA,
        setConfigDrug,
        setConfigSubSpeciality,
        setConfigAuditOptions,
        setConfigFeedbackTypes,
        setConfigHoldReasons,
        setConfigResponsibleParties,
        setConfigDisposition,
        setConfigPrimaryHealth,
        setConfigFacility,
        setMessageSave,
        setFieldValidationConfig,
        setConfigurableFieldsCount,
        onformCancel,
        doesLocationSupportProcessWiseCoding,
        setDoesLocationSupportProcessWiseCoding,
      }}
    >
      {children}
    </Configurationcontext.Provider>
  );
};
export default ConfigurationContextProvider;
